import React from 'react';
import styled from 'styled-components';

export interface BreadcrumbItem {
    label: string;
    onClick?: () => void;
}

const Nav = styled.nav`
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: #999;
`;

const Separator = styled.span`
    color: #ddd;
`;

const Link = styled.span`
    color: #666;
    cursor: pointer;
    font-weight: 400;

    &:hover {
        color: #222;
    }
`;

const Current = styled.span`
    color: #222;
    font-weight: 500;
`;

export const Breadcrumb: React.FC<{ items: BreadcrumbItem[] }> = ({ items }) => (
    <Nav aria-label="Breadcrumb">
        {items.map((item, i) => (
            <React.Fragment key={i}>
                {i > 0 && <Separator>/</Separator>}
                {item.onClick ? (
                    <Link onClick={item.onClick}>{item.label}</Link>
                ) : (
                    <Current>{item.label}</Current>
                )}
            </React.Fragment>
        ))}
    </Nav>
);
